import React from "react";
import { Table } from "antd";
import "./index.less";

function TableData(props) {
  const { data } = props;
  const processTableData = (data) => {
    // 生成 columns 配置
    const columns = [
      {
        title: data.dim_field.name,
        dataIndex: data.dim_field.field,
        key: data.dim_field.field,
      },
      ...data.metric_fields.map((metric) => ({
        title: metric.name,
        dataIndex: metric.field,
        key: metric.field,
        // 可选：如果是数字，可以添加对齐方式
        align: "right",
      })),
    ];

    // 生成 dataSource
    const dataSource = data.data.map((row, index) => {
      const rowObj = {
        key: index, // Antd Table 需要唯一的 key
        [data.dim_field.field]: row[0],
      };

      // 动态映射指标字段
      data.metric_fields.forEach((metric, i) => {
        rowObj[metric.field] = row[i + 1];
      });

      return rowObj;
    });

    return { columns, dataSource };
  };
  const { columns, dataSource } = processTableData(data);
  return (
    <div className="tableData">
      <Table
        // columns={columns}
        columns={[{
          title:"年份",
          dataIndex:"nf"
        },{
          title:"男生人数",
          dataIndex:"malers"
        },{
          title:"女生人数",
          dataIndex:"femalers"
        }]}
        // dataSource={dataSource}
        dataSource={[{
          nf:"2023",
          malers:1200,
          femalers:1000
        },{
          nf:"2024",
          malers:1400,
          femalers:1150
        },{
          nf:"2025",
          malers:1300,
          femalers:1077
        },{
          nf:"2026",
          malers:1500,
          femalers:1301
        },]}
        // bordered
        pagination={false}
      />
    </div>
  );
}

export default TableData;
